import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Content } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
import { Link } from 'react-router-dom';
import { AddThemeContent } from './components';
import { useParams } from 'react-router-dom';
import 'react-simple-hook-modal/dist/styles.css';
import axios from 'axios';
import {
  ModalProvider,
  Modal,
  useModal,
  ModalTransition,
} from 'react-simple-hook-modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileBase from 'react-file-base64';

export default function Home() {
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const { isModalOpen, openModal, closeModal } = useModal();
  const [dataThemeOper, setDataThemeOper] = useState({
    fontType: '',
    paperColor: '',
    backgroundPaperColor: '',
    backgroundImagePaperColor: ``,
    questionColor: '',
    answerColor: '',
    stripColor: '', 
    backgroundButtonColor: '',
  });

  const [themeName, setThemeName] = useState('');
  const [themeDesc, setThemeDesc] = useState('');
  const [themePict, setThemePict] = useState('');
  const [themeType, setThemeType] = useState('');

  const [themeImg, setThemeImg] = useState('')

  const pull_data = (data) => {
    setDataThemeOper(data);
    console.log('ini data each', data.paperColor);
  };

  let contentUi = <div className='loader-block' />;
  if (!dataThemeOper.isLoading) {
    contentUi = (
      <React.Fragment>
        <AddThemeContent func={pull_data} />
      </React.Fragment>
    );
  }

  const option = ['BASIC', 'PRO'];

  const handleChangeThemeName = (e) => {
    setThemeName(e.target.value);
  };
  const handleChangeThemeDesc = (e) => {
    setThemeDesc(e.target.value);
  };

  const Types = option.map((Type) => Type);
  const handleTypeChange = (e) => {
    console.log(themeType[e.target.value]);
    setThemeType(option[e.target.value]);
  };

  console.log('ini dataThemeOper', dataThemeOper);

  useEffect(() => {
    document.title = `Add Theme - Ubaform Admin`;
  }, []);

  

  const commitToDB = () => {
    // e.prevent.Default();
    const data = {
      style: dataThemeOper,
      name: themeName,
      description: themeDesc,
      selectedFile: themeImg,
      type: themeType,
    };
    console.log('ini data All theme', data);
    axios
      .post('https://apiubaforms.herokuapp.com/api/v1/add-theme', data)
      .then((response, error) => {
        if (error) {
          response.status(400).send({ message: error.message });
        }
        if (!error) {
          toast.success(response.data.message);
          console.log(response.data.message);
        }
      });
  };

  return (
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      <main className='workspace'>
        <section className='breadcrumb lg:flex items-start'>
          <div>
            <h1>Add New Theme</h1>
            <ul>
              <li>
                <Link to='/theme-management'>Theme</Link>
              </li>

              <li className='divider la la-arrow-right'></li>
              <li>Add New Theme</li>
            </ul>
          </div>
          <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
            <div className='flex mt-5 lg:mt-0'>
              <button
                // to={`/theme-management/add/${id}`}
                onClick={openModal}
                // onClick={pull_data()}
                // onClick={commitToDB}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Publish theme
              </button>
              <Link
                to='/theme-management'
                className='bg-transparent text-primary font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Back to list
              </Link>
            </div>
          </div>
        </section>
        <ModalProvider>
          {/* <MyComponent /> */}
          <Modal
            id='any-unique-identifier'
            isOpen={isModalOpen}
            transition={ModalTransition.SCALE}
          >
            <form
              className='w-full max-w-lg justify-center'
              onSubmit={commitToDB}
            >
              <div className='sm:grid-cols-2 grid sm:gap-7 gap-3 mt-6'>  
                <div className=' overflow-hidden rounded-lg'>
              
                  <div className='w-full py-3'>
                    <label
                      className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                      for='theme-name'
                    >
                      Enter Theme Name
                    </label>
                    <input
                      className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                      id='theme-name'
                      type='text'
                      placeholder='Elegant Theme'
                      // required={true}
                      name='name'
                      value={themeName}
                      onChange={handleChangeThemeName}
                    />
                  </div>
                  <div className='w-full pt-3'>
                    <label
                      className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                      for='theme-description'
                    >
                      Enter Theme Description
                    </label>
                    <textarea
                      className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                      id='theme-description'
                      type='text'
                      placeholder='Great theme for make your time happy'
                      rows={12}
                      value={themeDesc}
                      onChange={handleChangeThemeDesc}
                      // required
                    />
                  </div>
                  <div className='w-full py-10'>
                    <label
                      className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                      for='grid-state'
                    >
                      Chose Theme's Type
                    </label>
                    <div className='relative'>
                      <select
                        className='block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='grid-state'
                        onChange={(e) => handleTypeChange(e)}
                        // required
                      >
                        {Types.map((address, key) => (
                          <option value={key}>{address}</option>
                        ))}
                      </select>
                      <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700'>
                        <svg
                          className='fill-current h-4 w-4'
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 20 20'
                        >
                          <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='overflow-hidden rounded-lg '>
                  
                    <div className='mt-2 flex flex-col'>
                      
                        <FileBase
                          type='file'
                          className='hidden'
                          multiple={false}
                          onDone={({ base64 }) =>
                            setThemeImg(base64)
                          }
                        />
                                        
                      
                      <img src={themeImg} />
                      {/* <p>{templateImg}</p> */}
                    </div>
                
                </div>
              </div>
            </form>
            <div className='flex mt-5 lg:mt-0'>
              <button
                // type='submit'
                onClick={commitToDB}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Save theme
              </button>
              <button
                onClick={closeModal}
                className='bg-transparent text-red-500 font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Cancel
              </button>
            </div>
          </Modal>
        </ModalProvider>

        {contentUi}

        <Footer />
      </main>
    </div>
  );
}
